import heydoctor from 'app/vendor/heydoctor';
import { omit } from 'lodash';
import { cookies } from 'app/lib/storage';
import { Stores, Store } from 'app/lib/synaptik';

interface State {
  fetchingPromotion?: boolean;
  promotion: any;
}

export class PromotionsStore extends Store<State, Stores> {
  state: State = {
    promotion: null,
  };

  fetchPromotion = async () =>
    this.runAsync({
      key: 'fetchingPromotion',
      work: async () => {
        const { queryParams } = cookies.get();

        if (queryParams?.promoCode) {
          const promotion = await heydoctor.promotions.fetchPromotion(queryParams.promoCode);

          if (promotion.invalid) {
            cookies.set('queryParams', omit(queryParams, ['promoCode']));
          }

          this.setState({ promotion });

          return promotion;
        }

        return null;
      },
    });
}
